import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DepreciationTransaction  {
    _originalTypeClassName = "zERP.BO.DepreciationTransaction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DepreciationTransaction.translate = translateService;
}
this.Transactions = [];
this.TaxPreview = new Domain.DepreciationPreview();
this.AccountingPreview = new Domain.DepreciationPreview();
this.GeneralJournals = [];
this.Categories = [];
this.Id = null;
this.ReferenceDate = null;
this.CreatedAt = null;
this.IsFinalized = false;
this.FinalizedAt = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ReferenceDate:any;
CreatedAt:any;
IsFinalized:any;
FinalizedAt:any;
Transactions:any;
TaxPreview:any;
AccountingPreview:any;
GeneralJournals:any;
Invoice:any;
Categories:any;
static setTransactions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Transactions == null) $this.Transactions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Transactions.length > 0) {
                    Domain.DepreciationTransaction.removeTransactions($this, $this.Transactions[0]);
                }

                Domain.DepreciationTransaction.addManyTransactions($this, copyItems);
            }
static addManyTransactions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.DepreciationTransaction.addTransactions($this, items[i]);
                }
            }
static addTransactions = ($this, item) => {
                if ($this.Transactions == null) $this.Transactions = [];
                if (item == null || $this.Transactions.indexOf(item) > -1) return;
                $this.Transactions.push(item);
}
static addRangeTransactions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.DepreciationTransaction.addTransactions($this, item));
            }
static removeTransactions = ($this, item) => {
                if ($this == null || $this.Transactions == null || $this.Transactions.indexOf(item) === -1) return;
                var _index = $this.Transactions.indexOf(item);
                $this.Transactions.splice(_index, 1);
}
static clearTransactions = ($this) => { $this.Transactions = null; }
static setTaxPreview = ($this, value) => {
var oldValue = $this.TaxPreview;
$this.TaxPreview = value;
if (value != null) {
}
}
static setAccountingPreview = ($this, value) => {
var oldValue = $this.AccountingPreview;
$this.AccountingPreview = value;
if (value != null) {
}
}
static setGeneralJournals = ($this, items) => {
                if (items == null) items = [];
                if ($this.GeneralJournals == null) $this.GeneralJournals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.GeneralJournals.length > 0) {
                    Domain.DepreciationTransaction.removeGeneralJournals($this, $this.GeneralJournals[0]);
                }

                Domain.DepreciationTransaction.addManyGeneralJournals($this, copyItems);
            }
static addManyGeneralJournals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.DepreciationTransaction.addGeneralJournals($this, items[i]);
                }
            }
static addGeneralJournals = ($this, item) => {
                if ($this.GeneralJournals == null) $this.GeneralJournals = [];
                if (item == null || $this.GeneralJournals.indexOf(item) > -1) return;
                $this.GeneralJournals.push(item);
}
static addRangeGeneralJournals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.DepreciationTransaction.addGeneralJournals($this, item));
            }
static removeGeneralJournals = ($this, item) => {
                if ($this == null || $this.GeneralJournals == null || $this.GeneralJournals.indexOf(item) === -1) return;
                var _index = $this.GeneralJournals.indexOf(item);
                $this.GeneralJournals.splice(_index, 1);
}
static clearGeneralJournals = ($this) => { $this.GeneralJournals = null; }
static setInvoice = ($this, value) => {
var oldValue = $this.Invoice;
$this.Invoice = value;
if (value != null) {
}
}
static setCategories = ($this, items) => {
                if (items == null) items = [];
                if ($this.Categories == null) $this.Categories = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Categories.length > 0) {
                    Domain.DepreciationTransaction.removeCategories($this, $this.Categories[0]);
                }

                Domain.DepreciationTransaction.addManyCategories($this, copyItems);
            }
static addManyCategories = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.DepreciationTransaction.addCategories($this, items[i]);
                }
            }
static addCategories = ($this, item) => {
                if ($this.Categories == null) $this.Categories = [];
                if (item == null || $this.Categories.indexOf(item) > -1) return;
                $this.Categories.push(item);
}
static addRangeCategories = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.DepreciationTransaction.addCategories($this, item));
            }
static removeCategories = ($this, item) => {
                if ($this == null || $this.Categories == null || $this.Categories.indexOf(item) === -1) return;
                var _index = $this.Categories.indexOf(item);
                $this.Categories.splice(_index, 1);
}
static clearCategories = ($this) => { $this.Categories = null; }

static GetClassName(): any{return "DepreciationTransaction";
}
static LinkWithInvoice($this: any, invoice: any): any{Domain.DepreciationTransaction.setInvoice($this, invoice);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}